import Vue from 'vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const options = {
  icons: {
    iconfont: 'md' // default - only for display purposes
  },
  theme: {
    light: {
      primary: '#00A3AD',
      secondary: '#FDCC08',
      third: '#006280',
      error: '#b71c1c',
      correct: '#172659',
      incorrect: '#FF6E7E'
    },
    options: {
      customProperties: true
    }
  }
}

Vue.use(Vuetify, options)

export default new Vuetify(options)
